<template>
    <div class="ita-index-container">
        <div class="btn-row" v-if="getUser.userType == '1'">
            <div class="status">
                <div class="status-item" v-for="(v, k) in statusOptions" :key="k">
                    <img :src="v.icon" class="status-icon" />
                    <div class="status-text">{{ $t(v.label) }}</div>
                </div>
            </div>
            <div class="btns">
                <el-button class="wl-green" @click="onAddClick">
                    <i class="el-icon-plus"></i>
                    {{ $t('ita_add_qa') }}
                </el-button>
                <el-button class="wl-green" @click="HandleNotifyClientClick" :disabled="chooseable">
                    <img :src="exportIcon" />
                    {{ $t('ita_btn_notify_client') }}
                </el-button>
                <el-button class="wl-green" @click="HandleArchiveQuestionnaireClick" :disabled="chooseable">
                    <img :src="exportIcon" />
                    {{ $t('ita_btn_archive_questionnaire') }}
                </el-button>
            </div>
        </div>
        <div class="table">
            <el-table
                border
                height="100%"
                :data="list"
                @selection-change="onTableSelectChange"
                v-loading="loading"
                :span-method="objectSpanMethod"
                ref="itaTable"
            >
                <!-- 选择列 -->
                <el-table-column align="center" type="selection" width="50" resizable v-if="getUser.userType == '1'&&chooseable" class-name="border-bottom"></el-table-column>

                <!-- 实体 -->
                <el-table-column
                    :label="$t('TABLE_HEAD_EntityList')"
                    prop="entityName"
                    header-align="center"
                    resizable
                    show-overflow-tooltip
                    class-name="border-bottom"
                ></el-table-column>

                <!-- 章节 -->
                <el-table-column width="150" header-align="center" resizable show-overflow-tooltip >
                    <template #header>
                        <div class="table-header">
                            {{ $t('ita_table_header_section') }}
                            <MultiSelectPopver
                                :hidePopperSearch="getList"
                                :value.sync="search.section"
                                labelKey="sectionI18n"
                                valueKey="id"
                                :inputFilterKey="['sectionI18n', 'id']"
                                :options="displaySectionOptions"
                                iconColor="#3879eb"
                                iconSize="15"
                            ></MultiSelectPopver>
                        </div>
                    </template>
                    <div class="table-cell table-cell-section" slot-scope="scope" @click="onSectionClick(scope.row)">
                        <!-- {{ scope.row.sectionName }} -->
                        {{ $i18n.locale == 'zh' ? scope.row.sectionNameCn : scope.row.sectionName }}
                    </div>
                </el-table-column>

                <!-- 状态 -->
                <el-table-column width="150" align="center" header-align="center" resizable show-overflow-tooltip>
                    <div class="table-header" slot="header">
                        <el-dropdown style="margin-right: 5px;" @command="(v) => onBatchUpdate('status', v)" v-if="getUser.userType == '1'">
                            <span class="el-dropdown-link">
                                <i class="el-icon-edit-outline table-header-edit-cls table-header-blue-icon"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                    v-for="v in statusOptions"
                                    :key="v.value"
                                    :command="v.value"
                                    :value="v.value"
                                    style="font-size: 12px"
                                >
                                    <span class="status-dropdown-item">
                                        <img :src="v.icon" />
                                        {{ $t(v.label) }}
                                    </span>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        {{ $t('ita_table_header_status') }}
                        <MultiSelectPopver
                            :hidePopperSearch="getList"
                            :value.sync="search.status"
                            labelKey="xlabel"
                            valueKey="value"
                            :inputFilterKey="['xlabel', 'value']"
                            :options="statusOptions.map((v) => ({ xlabel: $t(v.label), ...v }))"
                            iconColor="#3879eb"
                            iconSize="15"
                        ></MultiSelectPopver>
                    </div>
                    <div class="table-cell" slot-scope="scope">
                        <el-dropdown @command="(v) => onSingleUpdate('status', v, scope.row)" v-if="getUser.userType == '1'">
                            <span class="status-dropdown-item">
                                <img :src="statusValueToIcon(scope.row.status)" />
                                <span class="text" :style="{ color: statusValueToColor(scope.row.status) }">{{
                                    statusValueToLabel(scope.row.status)
                                }}</span>
                                <i class="el-icon-caret-bottom"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                    v-for="v in statusOptions"
                                    :key="v.value"
                                    :command="v.value"
                                    :value="v.value"
                                    style="font-size: 12px"
                                >
                                    <span class="status-dropdown-item">
                                        <img :src="v.icon" />
                                        {{ $t(v.label) }}
                                    </span>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <span class="status-dropdown-item status-dropdown-item-inactive" v-else>
                            <img :src="statusValueToIcon(scope.row.status)" />
                            <span class="text" :style="{ color: statusValueToColor(scope.row.status) }">{{
                                statusValueToLabel(scope.row.status)
                            }}</span>
                        </span>
                    </div>
                </el-table-column>

                <!-- 客户联系人 -->
                <el-table-column width="250" align="center" header-align="center" resizable show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <div class="table-header">
                            <el-dropdown style="margin-right: 5px;" trigger="click" @command="(v) => onBatchUpdate('clientResponsible', v)">
                                <span class="el-dropdown-link">
                                    <i class="el-icon-edit-outline table-header-edit-cls table-header-blue-icon"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-input
                                        v-model="clientOwnerFilterInput"
                                        size="mini"
                                        :placeholder="$t('ita_table_header_client_responsible')"
                                        clearable
                                    ></el-input>
                                    <el-dropdown-item
                                        v-for="v in displayClientOwnerList"
                                        :key="v.id"
                                        :command="v.id"
                                        :value="v.id"
                                        style="font-size: 12px"
                                    >
                                        <span class="status-dropdown-item"> {{ v.userName }}({{ v.email }}) </span>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            {{ $t('ita_table_header_client_responsible') }}
                            <MultiSelectPopver
                                :hidePopperSearch="getList"
                                :value.sync="search.clientResponsible"
                                labelKey="xlabel"
                                valueKey="id"
                                :inputFilterKey="['id', 'email', 'userName', 'xlabel']"
                                :options="clientOwnerList.map((v) => ({ xlabel: `${v.userName}(${v.email})`, ...v }))"
                                iconColor="#3879eb"
                                iconSize="15"
                            ></MultiSelectPopver>
                        </div>
                    </template>
                    <div class="table-cell" slot-scope="scope">
                        <span class="status-dropdown-item">
                            <span class="text">
                                {{
                                    scope.row.clientOwnerList.find((v) => v.id == scope.row.clientResponsible)
                                        ? scope.row.clientOwnerList.find((v) => v.id == scope.row.clientResponsible).userName +
                                            `(${scope.row.clientOwnerList.find((v) => v.id == scope.row.clientResponsible).email})`
                                        : ''
                                }}
                            </span>
                            <i class="el-icon-edit table-header-blue-icon" @click="onUpdateClientClick(scope.row)"></i>
                        </span>
                        <!-- <el-dropdown class="client-dropdown" @command="(v) => onSingleUpdate('clientResponsible', v, scope.row)">
                            
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                    v-for="v in scope.row.clientOwnerList"
                                    :key="v.id"
                                    :command="v.id"
                                    :value="v.id"
                                    style="font-size: 12px"
                                >
                                    <span class="status-dropdown-item"> {{ v.userName }}({{ v.email }}) </span>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown> -->
                    </div>
                </el-table-column>

                <!-- 期末时间 -->
                <el-table-column width="180" align="center" header-align="center" resizable show-overflow-tooltip>
                    <div class="table-header" slot="header">
                        <DatePickerPopover
                            style="margin-right: 5px;"
                            v-if="getUser.userType == '1'"
                            :rangeSelect="false"
                            :value.sync="patchEditPeriodDate"
                            :hidePopperSearch="(e) => onBatchUpdate('periodEndDate', e)"
                        >
                            <i slot="icon" class="el-icon-edit-outline table-header-edit-cls table-header-blue-icon"></i>
                        </DatePickerPopover>
                        {{ $t('ita_table_header_period_date') }}
                        <DatePickerPopover :hidePopperSearch="getList" :value.sync="search.periodDate"></DatePickerPopover>
                    </div>
                    <div class="table-cell" slot-scope="scope">
                        {{ scope.row.periodEndDate | formatDate }}
                        <DatePickerPopover
                            v-if="getUser.userType == '1'"
                            :rangeSelect="false"
                            :hidePopperSearch="(e) => onSingleUpdate('periodEndDate', e, scope.row)"
                        >
                            <i slot="icon" class="el-icon-edit table-header-blue-icon"></i>
                        </DatePickerPopover>
                    </div>
                </el-table-column>

                <!-- 截止日期 -->
                <el-table-column width="180" align="center" header-align="center" show-overflow-tooltip>
                    <div class="table-header" slot="header">
                        <DatePickerPopover
                            style="margin-right: 5px;"
                            v-if="getUser.userType == '1'"
                            :rangeSelect="false"
                            :value.sync="patchDueDate"
                            :hidePopperSearch="(e) => onBatchUpdate('dueDate', e)"
                        >
                            <i slot="icon" class="el-icon-edit-outline table-header-edit-cls table-header-blue-icon"></i>
                        </DatePickerPopover>
                        {{ $t('ita_table_header_due_date') }}
                        <DatePickerPopover :hidePopperSearch="getList" :value.sync="search.dueDate"></DatePickerPopover>
                    </div>
                    <div class="table-cell" slot-scope="scope">
                        {{ scope.row.dueDate | formatDate }}
                        <DatePickerPopover
                            v-if="getUser.userType == '1'"
                            :rangeSelect="false"
                            :hidePopperSearch="(e) => onSingleUpdate('dueDate', e, scope.row)"
                        >
                            <i slot="icon" class="el-icon-edit table-header-blue-icon"></i>
                        </DatePickerPopover>
                    </div>
                </el-table-column>

                <!-- 最后更新人 -->
                <el-table-column width="150" align="center" header-align="center" resizable show-overflow-tooltip>
                    <div class="table-header" slot="header">
                        {{ $t('ita_table_header_last_update_by') }}
                        <MultiSelectPopver
                            :hidePopperSearch="getList"
                            :value.sync="search.lastUpdateBy"
                            labelKey="xlabel"
                            valueKey="xid"
                            :inputFilterKey="['xid', 'xlabel']"
                            :options="lastUpdateByOptions"
                            iconColor="#3879eb"
                            iconSize="15"
                        ></MultiSelectPopver>
                    </div>
                    <template slot-scope="scope">
                        {{ scope.row.updateUser }}
                    </template>
                </el-table-column>

                <!-- 最后更新时间 -->
                <el-table-column
                    width="150"
                    align="center"
                    header-align="center"
                    :label="$t('ita_table_header_last_update_time')"
                    resizable
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        {{ scope.row.updateDate | formatDateTime }}
                    </template>
                </el-table-column>

                <!-- 删除 -->
                <el-table-column
                    width="150"
                    align="center"
                    header-align="center"
                    :label="$t('ita_table_header_delete')"
                    v-if="getUser.userType == '1'"
                    resizable
                    class-name="border-bottom"
                >
                    <div class="table-cell table-cell-delete" slot-scope="scope" @click="onDeleteClick(scope.row)">
                        <i class="el-icon-delete"></i>
                    </div>
                </el-table-column>
            </el-table>
        </div>
        <div class="footer-btn" v-if="chooseable">
            <el-button class="cancel-btn" @click="cancelChoose" :disabled="!chooseable">
                {{ $t('btn_cancel') }}
            </el-button>
            <el-button class="wl-green" @click="onNotifyClientClick" :disabled="chooseable && tableSelectedRows.length == 0" v-show="multiChoose.mode == 'email'">
                <img :src="exportIcon" />
                {{ $t('ita_btn_notify_client') }}
            </el-button>
            <el-button class="wl-green" @click="onArchiveQuestionnaireClick" :disabled="chooseable && tableSelectedRows.length == 0" v-show="multiChoose.mode == 'questionnaire'">
                <img :src="exportIcon" />
                {{ $t('ita_btn_archive_questionnaire') }}
            </el-button>
        </div>

        <el-pagination
            class="wl-pagination"
            :current-page.sync="page"
            :page-size.sync="limit"
            @current-change="onCurrentPageChange"
            @size-change="onSizeChange"
            layout="prev, pager, next, slot, total"
            :total="total"
        >
            <span>
                <el-select v-model="limit" @change="onSizeChange">
                    <el-option v-for="item in pageOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
            </span>
        </el-pagination>

        <addQuestionnaire :show.sync="add.show" :bindData.sync="add.data" :handleSave="onAddCommit"></addQuestionnaire>
        <noticeUndone :show.sync="showNoticeUndone" :summaryList="noticeUndoneSummaryList"></noticeUndone>
        <updateClientResponsible
            :show.sync="updateClientResponsible.show"
            :options="updateClientResponsible.options"
            :onConfirm="confirmUpdateClientResponsible"
            :value.sync="updateClientResponsible.value"
        ></updateClientResponsible>
    </div>
</template>
<script>
import icon1 from '@/assets/img/icon-not-started.svg'
import icon2 from '@/assets/img/icon-in-progress.svg'
import icon3 from '@/assets/img/icon-completed.svg'
import exportIcon from '@/assets/img/icon-export.svg'
import API from '@/api'
import MultiSelectPopver from '@/components/common/MultiSelectPopver.vue'
import { mapGetters } from 'vuex'
import addQuestionnaire from './components/addQuestionnaire.vue'
import DatePickerPopover from '@/components/common/DatePickerPopover.vue'
import { deleteConfirm, isIE, dateFormat } from '@/utils'
import noticeUndone from './components/noticeUndone'
import updateClientResponsible from './components/updateClientResponsible.vue'

export default {
    name: 'ITA',
    components: { MultiSelectPopver, addQuestionnaire, DatePickerPopover, noticeUndone, updateClientResponsible },
    props: {
        entityData: {
            type: Array,
            default: () => []
        },
        toogleClearFilterActive: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            exportIcon,
            add: {
                show: false,
                data: []
            },
            search: {
                section: [],
                status: [],
                clientResponsible: [],
                periodDate: [],
                dueDate: [],
                lastUpdateBy: []
            },
            list: [],
            page: 1,
            limit: 12,
            total: 0,
            pageOptions: [
                { label: '12/' + this.$t('page'), value: 12 },
                { label: '24/' + this.$t('page'), value: 24 },
                { label: '36/' + this.$t('page'), value: 36 },
                { label: '48/' + this.$t('page'), value: 48 },
                { label: this.$t('pagination_all'), value: 10000000 }
            ],
            loading: false,
            tableSelectedRows: [],
            statusOptions: [
                {
                    label: 'ita_status_not_started',
                    icon: icon1,
                    value: 3,
                    color: '#fd349c'
                },
                {
                    label: 'ita_status_in_progress',
                    icon: icon2,
                    value: 2,
                    color: '#00b8f5'
                },
                {
                    label: 'ita_status_icon_completed',
                    icon: icon3,
                    value: 4,
                    color: '#00c0ae'
                }
            ],
            clientOwnerList: [],
            clientOwnerFilterInput: '',
            kpmgUserList: [],
            sectionOptions: [],
            patchEditPeriodDate: '',
            patchDueDate: '',
            showNoticeUndone: false,
            noticeUndoneSummaryList: [],
            updateClientResponsible: {
                show: false,
                id: '',
                options: [],
                value: ''
            },
            chooseable: false,
            multiChoose: {
                mode: '' // questionnaire | email
            },
        }
    },
    async mounted() {
        await this.getUserEntity()
        this.getOptions()
        this.getList()
    },
    methods: {
        cancelChoose() {
            this.$refs.itaTable.clearSelection()
            this.chooseable = false
            this.multiChoose.mode = ''
        },
        onUpdateClientClick(row) {
            this.updateClientResponsible.show = true
            this.updateClientResponsible.id = row.id
            this.updateClientResponsible.options = row.clientOwnerList
            this.updateClientResponsible.value = row.clientResponsible
        },
        async confirmUpdateClientResponsible(v) {
            this.loading = true
            const { code } = await API.exchange.itaUpdate( {
                id: this.updateClientResponsible.id,
                clientResponsible: v
            })
            if (code != '1') {
                this.$message.error(this.$t(code))
            } else {
                const findRow = this.list.find(v => v.id == this.updateClientResponsible.id)
                 
                if (findRow) {
                    findRow.clientResponsible = v
                }
            }
            this.loading = false
            this.updateClientResponsible.show = false
            this.updateClientResponsible.id = ''
            this.updateClientResponsible.options = []
        },
        onClientOwnerFilterInput(e) {
             
            this.$nextTick(() => {
                this.$forceUpdate()
            })
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            //批量选择涉及到列序号的变更
            if (
                (this.chooseable&&(this.getUser.userType == '1' && [0, 1, 9].includes(columnIndex) ||
                this.getUser.userType == '2' && [0].includes(columnIndex)) )||
                (!this.chooseable&&(this.getUser.userType == '1' && [0, 8].includes(columnIndex) ||
                this.getUser.userType == '2' && [0].includes(columnIndex)) )
            ) {
                return rowIndex % 6 === 0
                    ? {
                          rowspan: 6,
                          colspan: 1
                      }
                    : {
                          rowspan: 0,
                          colspan: 0
                      }
            }
        },
        getOptions() {
            API.exchange
                .querySelectList({ siteId: this.getSite.siteId })
                .then((res) => {
                    if (res.code != '1') {
                        this.$message.error(this.$t(res.code))
                        return
                    }
                    this.sectionOptions = res.data.sectionList.map((v) => {
                        v.sectionI18n = this.$i18n.locale == 'zh' ? v.sectionCn : v.section
                        return v
                    })
                    this.kpmgUserList = res.data.kpmgUserList
                    this.clientOwnerList = res.data.clientOwnerList
                    this.clientOwnerList.map(item => {
                        if(item.userName === 'Blank') {
                            item.userName = this.$t('common_empty')
                            item.email = this.$t('common_empty')
                        }
                    })
                })
                .catch((e) => {
                    console.error(e)
                })
        },
        // 当entity筛选改变，由父组件触发
        onEntitySelect(e) {
            this.getList()
        },
        async getUserEntity() {
            const { code, data } = await API.common.queryUserEntity({ siteId: this.getSite.siteId, exchangeType: '0', menuId:'20', userType: this.getUser.userType })
            if (code == '1') {
                this.add.data = [data]
            } else {
                this.$message.error(this.$t(code))
            }
        },
        onAddCommit(e) {
            if (!e || e.length == 0) {
                this.$message.error(this.$t('CLIENT_ROLE_ENTITY'))
                return
            }
            return API.exchange
                .itaAdd({
                    entityList: e,
                    siteId: this.getSite.siteId
                })
                .then((res) => {
                    if (res.code == '1') {
                        this.$message.success(this.$t('msg_save_success'))
                        this.add.show = false
                        this.page = 1
                        this.getList()
                    } else {
                        if (res.code == 'ITU_ENTITY_REPEAT') {
                            this.$message.error(this.$t('itu_entity_add_repeat', {entities: res.data.join(',')}))
                        } else {
                            this.$message.error(this.$t(res.code))
                        }
                    }
                })
        },
        onAddClick() {
            this.add.show = true
        },
        onSectionClick(v) {
            this.$router.push(`/ita?entityId=${v.entityId}&sectionId=${v.sectionId}`)
        },
        onDeleteClick(v) {
             
            if (v.status != 3) {
                this.$message.error(this.$t('itu_list_delete_forbid'))
                return
            }
            if (this.list.some((vv) => vv.entityId == v.entityId && vv.status != 3)) {
                this.$message.error(this.$t('itu_list_delete_forbid_2'))
                return
            }
            deleteConfirm(this.$t('itu_delete_notice')).then(() => {
                this.loading = true
                API.exchange
                    .deleteItu({
                        entityId: v.entityId
                    })
                    .then((res) => {
                        if (res.code == '1') {
                            this.$message.success(this.$t('msg_success'))
                            this.page = 1
                            this.getList()
                        } else {
                            this.$message.error(this.$t(res.code))
                        }
                    })
                    .finally(() => {
                        this.loading = false
                    })
            })
        },
        async onSingleUpdate(column, v, row) {
            let sendData = {
                id: row.id
            }
            if (['dueDate', 'periodEndDate'].includes(column)) {
                v = new Date(v)
            }
            sendData[column] = v
            this.loading = true
            const { code } = await API.exchange.itaUpdate(sendData)
            if (code != '1') {
                this.$message.error(this.$t(code))
            } else {
                // row[column] = v
                this.getList()
            }
            this.loading = false
        },
        async onBatchUpdate(column, v) {
            // const ids = this.tableSelectedRows.map(v => v.id)
            // if (!ids || ids.length == 0) {
            //     this.$message.error(this.$t('ita_please_check_rows'))
            //     return
            // }
            let sendData = {
                ids: this.list.map((v) => v.id)
            }
            if (['dueDate', 'periodEndDate'].includes(column)) {
                v = new Date(v)
            }
            sendData[column] = v

            this.loading = true
            const { code } = await API.exchange.itaBatchUpdate(sendData)
            if (code != '1') {
                this.$message.error(this.$t(code))
            } else {
                this.getList()
                // this.list.filter(vv => this.list.map(vvv => vvv.id).includes(vv.id)).forEach(vv => {
                //     vv[column] = v
                //     vv.updateDate = (new Date()).toLocaleDateString()
                // })
            }
            this.loading = false
        },
        statusValueToColor(e) {
            const find = this.statusOptions.find((v) => v.value == e)
            return find && find.color ? find.color : ''
        },
        statusValueToIcon(e) {
            const find = this.statusOptions.find((v) => v.value == e)
            return find && find.icon ? find.icon : ''
        },
        statusValueToLabel(e) {
            const find = this.statusOptions.find((v) => v.value == e)
            return find && find.label ? this.$t(find.label) : ''
        },
        onCurrentPageChange() {
            this.getList()
        },
        onSizeChange() {
            this.getList()
        },
        onTableSelectChange(e) {
            this.tableSelectedRows = e
        },
        getList() {
            // if (!this.getEntityIds || this.getEntityIds.length == 0) return
            this.loading = true
            return API.exchange
                .getItaList({
                    userType: this.getUser.userType,
                    siteId: this.getSite.siteId,
                    exchangeType: 4,
                    menuId:'20',
                    pageNum: this.page,
                    pageSize: this.limit,
                    entityIdList: this.getEntityIds ? this.getEntityIds : [],
                    statusList: this.search.status,
                    sectionList: this.search.section,
                    clientResponsibleList: this.search.clientResponsible,
                    startPeriodDate: new Date(this.search.periodDate[0]),
                    endPeriodDate: new Date(this.search.periodDate[1]),
                    startDueDate: new Date(this.search.dueDate[0]),
                    endDueDate: new Date(this.search.dueDate[1]),
                    updateByList: this.search.lastUpdateBy
                })
                .then((res) => {
                    if (res.code == '1') {
                        this.list = res.data.records.map(v => {
                            if (!v.clientOwnerList) {
                                v.clientOwnerList = []
                            }
                            return v
                        })
                        this.total = res.data.total
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        HandleNotifyClientClick() {
            this.chooseable = true;
            this.multiChoose.mode = 'email'
        },
        HandleArchiveQuestionnaireClick() {
            this.chooseable = true;
            this.multiChoose.mode = 'questionnaire'
        },
        onNotifyClientClick() {
            if (this.tableSelectedRows.length == 0) {
                this.$message.error(this.$t('itu_please_check_rows_notice'))
                return
            }
            this.showNoticeUndone = true
            this.noticeUndoneSummaryList = this.list.filter(v => this.tableSelectedRows.map(vv => vv.entityId).includes(v.entityId)).filter(v => !!v).map((v, k) => {
                //  
                return {
                    serialNoStr: `${k - 0 + 1}`,
                    entityName: v.entityName,
                    sectionNameCn: v.sectionNameCn,
                    sectionName: v.sectionName,
                    statusCn: {
                        3: '未开始',
                        2: '进行中',
                        4: '已完成'
                    }[v.status],
                    status: {
                        3: 'Not started',
                        2: 'In progress',
                        4: 'Completed'
                    }[v.status],
                    periodEndDateStr: v.periodEndDate ? dateFormat(new Date(v.periodEndDate), 'yyyy-MM-dd') : '',
                    dueDateStr: v.dueDate ? dateFormat(new Date(v.dueDate), 'yyyy-MM-dd') : '',
                    clientResponsible: v.clientResponsible
                }
            })
        },
        onArchiveQuestionnaireClick() {
            if (this.tableSelectedRows.length == 0) {
                this.$message.error(this.$t('itu_please_check_rows_export'))
                return
            }
            this.loading = true
            const entityList = this.tableSelectedRows.map((v) => ({ id: v.entityId, entityName: v.entityName }))
            API.exchange
                .ituExportZip({
                    entityList,
                    siteId: this.getSite.siteId
                })
                .then((res) => {
                    if (/application\/json/.test(res.data.type)) {
                        let reader = new FileReader()
                        reader.onload = (e) => {
                            if (e.target.readyState === 2) {
                                let resJson = {}
                                resJson = JSON.parse(e.target.result)
                                this.$message.error({ duration: 5000, message: this.$t(resJson.code) })
                            }
                        }
                        reader.readAsText(res.data)
                    }
                    if (/application\/octet-stream/.test(res.data.type)) {
                        let blob = new Blob([res.data])
                        const filename = decodeURI(res.headers['content-disposition'].replace('attachment; filename=', ''))
                        if (isIE()) {
                            navigator.msSaveBlob(blob, filename)
                        } else {
                            let url = window.URL.createObjectURL(blob)
                            let link = document.createElement('a')
                            link.style.display = 'none'
                            link.href = url
                            link.setAttribute('download', filename)
                            document.body.appendChild(link)
                            link.click()
                        }
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        onClearFilter() {
            this.search = {
                section: [],
                status: [],
                clientResponsible: [],
                periodDate: [],
                dueDate: [],
                lastUpdateBy: []
            }
            this.page = 1
            this.getList()
        }
    },
    computed: {
        lastUpdateByOptions() {
            return [
                ...this.kpmgUserList.map(v => ({
                    xid: v.userAccount,
                    xlabel: `${v.userName}(${v.profitCenter})`
                })),
                ...this.clientOwnerList.map(v => ({
                    xid: v.userAccount,
                    xlabel: v.email
                }))
            ].filter(v => v.xid != 'Blank')
        },
        displayClientOwnerList() {
            const allClientFromList = this.list.reduce((pre, cur) => {
                if (pre.length == 0) {
                    pre = [...cur.clientOwnerList]
                } else {
                    pre = pre.filter(v => cur.clientOwnerList.map(vv => vv.id).includes(v.id))
                }
                return pre
            }, [])

            if (!this.clientOwnerFilterInput) {
                return allClientFromList
            }

            return allClientFromList.filter((v) => {
                return (
                    (v.email.toLowerCase().indexOf(this.clientOwnerFilterInput.toLowerCase()) > -1 ||
                    v.userName.toLowerCase().indexOf(this.clientOwnerFilterInput.toLowerCase()) > -1 ||
                    v.id.indexOf(this.clientOwnerFilterInput.toLowerCase()) > -1)
                )
            })
        },
        displaySectionOptions() {
            return [...this.sectionOptions]
        },
        ...mapGetters('common', {
            getSite: 'getSite',
            getUser: 'getUser',
            getEntityIds: 'getEntityIds'
        })
    },
    watch: {
        search: {
            deep: true,
            handler(v) {
                // section: [],
                // status: [],
                // clientResponsible: [],
                // periodDate: [],
                // dueDate: [],
                // lastUpdateBy: []
                this.toogleClearFilterActive && this.toogleClearFilterActive(false)
                if (
                    v.section.length > 0 ||
                    v.status.length > 0 ||
                    v.clientResponsible.length > 0 ||
                    v.periodDate.length > 0 && v.periodDate.every(v => v !== '') ||
                    v.dueDate.length > 0 && v.dueDate.every(v => v !== '') ||
                    v.lastUpdateBy.length > 0
                ) {
                    this.toogleClearFilterActive && this.toogleClearFilterActive(true)
                }
            }
        }
    }
}
</script>
<style scoped>

.footer-btn {
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.ita-index-container {
    display: flex;
    flex-direction: column;
}
.btn-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.btn-row .status {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.btn-row .status .status-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 20px;
}
.btn-row .status .status-item .status-text {
    margin-left: 5px;
    font-size: 12px;
}
.btn-row .btns {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.btn-row .btns img,
.btn-row .btns i {
    margin-right: 5px;
}
::v-deep .wl-green span {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.table {
    height: calc(100% - 50px - 70px);
    margin-top: 10px;
}
.wl-pagination {
    height: 40px;
}
.table ::v-deep .table-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}
.table-header-blue-icon {
    color: #3879eb;
    font-size: 15px;
    margin-left: 5px;
}
::v-deep .status-dropdown-item,
.status-dropdown-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
}
.status-dropdown-item-inactive {
    cursor: default;
}
.table-cell {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.table-cell .status-dropdown-item {
}
.table-cell-section {
    color: #4b85ec;
    text-decoration: underline;
    cursor: pointer;
    justify-content: left;
}
.table-cell-delete {
    color: #fd349c;
    cursor: pointer;
}
.table-cell-delete i {
    font-size: 18px;
}
::v-deep .status-dropdown-item img,
.table-cell .status-dropdown-item img {
    margin-right: 15px;
}
::v-deep .status-dropdown-item span,
.table-cell .status-dropdown-item span {
    margin-right: 15px;
}
.table-cell .status-dropdown-item i {
}
/* ::v-deep .el-table__body-wrapper {
    height: calc(100% - 42PX);
}
::v-deep .el-table__body {
    height: 100%;
} */
.table-cell .status-dropdown-item {
    width: 100%
}
.table-cell .status-dropdown-item .text {
    width: calc(100% - 15PX);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.el-dropdown-menu {
    max-height: 40vh;
    overflow-y: scroll;
}
::v-deep .border-bottom {
    border-bottom: 2PX solid #e6e6e8 !important;
}
    ::v-deep .el-table__row:nth-child(6n) .el-table__cell{
        border-bottom: 2PX solid #e6e6e8 !important;
    }
</style>